import React from "react";
import { Formik, Form } from "formik";
import Model from "../../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";
import { ProfileSection, UserInfo } from "../../Styles/PageStyles";

const EvictNowModal = ({
    setIsEvictNow,
    selectedData,
    evictNowLoading,
    evictNowMutate,
}) => {
    const initialValues = {
        tenantId: selectedData?.data?.id,
        totalDues: selectedData?.data?.totalDues,
        electricityReading: selectedData?.data?.lastSavedElecReading,
        discardDues: false,
        settleDues: false,
    };

    const handleAddSubmit = (values) => {
        evictNowMutate({ ...values });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsEvictNow}
            title="Evict Now"
        >
            <Formik initialValues={initialValues} onSubmit={handleAddSubmit}>
                {({ values, setFieldValue }) => (
                    <Form>
                        <Container>
                            <TenantInfo>

                                <div className="flex space-x-4">
                                    <UserInfo>
                                        <span className="font-medium">{selectedData?.data?.name}</span>
                                        <span className="text-sm text-gray-600">{selectedData?.data?.occupancy?.flatName ||
                                            selectedData?.data?.occupancy?.floor}, {selectedData?.data?.occupancy?.propName}</span>
                                    </UserInfo>
                                </div>
                                <DuesContainer>
                                    <DuesLabel>Total Dues</DuesLabel>
                                    <DuesAmount>₹{selectedData?.data?.totalDues}</DuesAmount>
                                </DuesContainer>
                            </TenantInfo>

                            <ManageDuesContainer>
                                <Label>
                                    Manage Dues <span className="text-red-500">*</span>
                                </Label>

                                {/* Settle Dues */}
                                <Option
                                    className={`${values.discardDues && values.settleDues ? "border-blue-500 bg-blue-100" : "border-gray-500"}`}
                                    onClick={() => {
                                        setFieldValue("discardDues", true);
                                        setFieldValue("settleDues", true);
                                    }}
                                >
                                    <Radio className={`${values.discardDues && values.settleDues ? "bg-blue-500" : ""}`}>
                                        {values.discardDues && values.settleDues && <InnerCircle />}
                                    </Radio>
                                    <span className="ml-3">Settle Dues - All dues have been cleared.</span>
                                </Option>

                                {/* Discard Dues */}
                                <Option
                                    className={`${values.discardDues && !values.settleDues ? "border-blue-500 bg-blue-100" : "border-gray-500"}`}
                                    onClick={() => {
                                        setFieldValue("discardDues", true);
                                        setFieldValue("settleDues", false);
                                    }}
                                >
                                    <Radio className={`${values.discardDues && !values.settleDues ? "bg-blue-500" : ""}`}>
                                        {values.discardDues && !values.settleDues && <InnerCircle />}
                                    </Radio>
                                    <span className="ml-3">Discard Dues - Remove dues without records.</span>
                                </Option>

                                {/* Not Cleared */}
                                <Option
                                    className={`${!values.discardDues && !values.settleDues ? "border-blue-500 bg-blue-100" : "border-gray-500"}`}
                                    onClick={() => {
                                        setFieldValue("discardDues", false);
                                        setFieldValue("settleDues", false);
                                    }}
                                >
                                    <Radio className={`${!values.discardDues && !values.settleDues ? "bg-blue-500" : ""}`}>
                                        {!values.discardDues && !values.settleDues && <InnerCircle />}
                                    </Radio>
                                    <span className="ml-3">Not Cleared - Keep for future reference.</span>
                                </Option>



                            </ManageDuesContainer>

                            <WarningText>
                                Warning: Are you sure you want to evict the tenant? This action
                                is irreversible and may affect the tenant’s agreement status.
                            </WarningText>

                            <div className="w-full flex justify-between space-x-6 my-4">
                                <SideCancelBtn
                                    type="button"
                                    onClick={() => setIsEvictNow(false)}
                                >
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn
                                    type="submit"
                                    disabled={evictNowLoading}
                                    className="border border-primary-color bg-white text-primary-color hover:bg-primary-color hover:text-white"
                                >
                                    {evictNowLoading ? "Loading..." : "Evict Now"}
                                </SubmitBtn>
                            </div>
                        </Container>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};
const Container = tw.div``;
const TenantInfo = tw.div`flex items-center space-x-4 mb-4 justify-between`;
const Profile = tw.div`w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center `;
const Name = tw.h3`text-lg font-semibold`;
const Address = tw.p`text-gray-500`;
const DuesContainer = tw.div`ml-auto `;
const DuesLabel = tw.p`text-gray-600 text-sm `;
const DuesAmount = tw.p`text-lg font-medium`;
const ManageDuesContainer = tw.div`mb-4`;
const Label = tw.label`block text-gray-600 font-normal mb-2`;
const Option = tw.div`p-3 border rounded-lg flex items-center cursor-pointer mt-2`;
const Radio = tw.div`w-5 h-5 flex items-center justify-center rounded-full border`;
const InnerCircle = tw.div`w-3 h-3 bg-white rounded-full`;
const WarningText = tw.p`text-red-500 text-sm mb-4`;

export default EvictNowModal;
